import { Link } from "react-router-dom";
import { useSiteContent } from "@/cms/SiteContentContext";
import { editableAttrs } from "@/cms/previewUtils";

const Footer = () => {
  const { content } = useSiteContent();
  const footer = content.footer;

  return (
    <footer style={{ backgroundColor: "#1a0808" }}>
      <div className="max-w-7xl mx-auto px-6 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/">
              <img
                src={content.navigation.logoSrc}
                alt={content.navigation.logoAlt}
                className="h-16 md:h-20 w-auto object-contain mb-4 cursor-pointer"
                {...editableAttrs("navigation.logoSrc", "image")}
              />
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed mt-3" {...editableAttrs("footer.description", "textarea")}>
              {footer.description}
            </p>
            <div className="flex items-center gap-4 mt-5" {...editableAttrs("footer.socialLinks", "array")}>
              {footer.socialLinks.map((s, index) => (
                <a
                  key={`${s.icon}-${index}`}
                  href={s.href}
                  target={s.href.startsWith("http") ? "_blank" : undefined}
                  rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="w-9 h-9 flex items-center justify-center border border-zinc-700 text-zinc-400 hover:text-white hover:border-red-600 transition-all duration-200 cursor-pointer"
                  {...editableAttrs(`footer.socialLinks.${index}.href`, "url")}
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-5" style={{ fontFamily: "Rajdhani, sans-serif" }}>
              Hızlı Menü
            </h4>
            <ul className="flex flex-col gap-2.5" {...editableAttrs("footer.links", "array")}>
              {footer.links.map((link, index) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-zinc-400 hover:text-red-500 text-sm flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap"
                    {...editableAttrs(`footer.links.${index}.label`, "text")}
                  >
                    <span className="w-1.5 h-1.5 bg-red-600 flex-shrink-0"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-5" style={{ fontFamily: "Rajdhani, sans-serif" }}>
              Hizmetlerimiz
            </h4>
            <ul className="flex flex-col gap-2.5" {...editableAttrs("footer.serviceLinks", "array")}>
              {footer.serviceLinks.map((s, index) => (
                <li key={`${s.href}-${index}`}>
                  <Link
                    to={s.href}
                    className="text-zinc-400 hover:text-red-500 text-sm flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap"
                    {...editableAttrs(`footer.serviceLinks.${index}.label`, "text")}
                  >
                    <span className="w-1.5 h-1.5 bg-red-600 flex-shrink-0"></span>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-5" style={{ fontFamily: "Rajdhani, sans-serif" }}>
              İletişim
            </h4>
            <ul className="flex flex-col gap-4" {...editableAttrs("footer.contactItems", "array")}>
              {footer.contactItems.map((item, index) => (
                <li key={`${item.icon}-${index}`} className="flex gap-3" {...editableAttrs(`footer.contactItems.${index}.text`, "textarea")}>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-red-500 text-base`}></i>
                  </div>
                  <span className="text-zinc-400 text-sm leading-relaxed" style={{ whiteSpace: "pre-line" }}>
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-800/60">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-zinc-500 text-xs" {...editableAttrs("footer.copyrightText", "text")}>
            © {new Date().getFullYear()} {footer.copyrightText}
          </p>
          <a
            href={footer.partnerUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-zinc-300 text-sm hover:text-white transition-colors"
          >
            <img src={footer.partnerLogo} alt="Partner Logo" className="h-6 w-auto object-contain" {...editableAttrs("footer.partnerLogo", "image")} />
            <p {...editableAttrs("footer.partnerText", "text")}>{footer.partnerText}</p>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
